import { PERMISSIONS } from './permissions.constants';

export const PERMISSION_GROUPS = {
    BOOKING_FULL_ACCESS: [
        PERMISSIONS.BOOKING.CREATE,
        // PERMISSIONS.BOOKING.EDIT,
        PERMISSIONS.BOOKING.CANCEL,
        PERMISSIONS.PRECONFIRM_BOOKING.CREATE,
        PERMISSIONS.CIRCUIT_BOOKING.CREATE,
        PERMISSIONS.BOOKING_CONFIRMATION.CREATE,
    ],
    REPORTS: [
        PERMISSIONS.PAYROLL_REPORT.VIEW,
        PERMISSIONS.INSIGHTS.VIEW,
        PERMISSIONS.ALL_REPORTS.VIEW,
    ],
    MANAGE: [
        PERMISSIONS.MY_LIST.VIEW,
        PERMISSIONS.SMART_GROUPS.VIEW,
        PERMISSIONS.INVITE.VIEW,
    ],
    DISCOVER: [
        PERMISSIONS.FIND_NEW_TEACHER.VIEW,
        PERMISSIONS.REQUEST.VIEW,
    ]
};